import React from 'react';
import { Card } from 'react-bootstrap';
import { Car } from 'providers/CarManagmentProvider';

interface CarInfoCardProps {
  car: Car | null;
}

const CarInfoCard: React.FC<CarInfoCardProps> = ({ car }) => {
  return (
    <Card className="car-details-card">
      {/* <style>{customStyles}</style> */}
      <Card.Body className="car-details-card-body">
        <div className="car-details-row">
          <div className="compact-label">Matrícula:</div>
          <div className="compact-value">{car?.carPlate}</div>
        </div>
        <div className="car-details-row">
          <div className="compact-label">Marca:</div>
          <div className="compact-value">{car?.marca}</div>
        </div>
        <div className="car-details-row">
          <div className="compact-label">Modelo:</div>
          <div className="compact-value">{car?.modelo}</div>
        </div>
        <div className="car-details-row">
          <div className="compact-label">Ano de Fabrico:</div>
          <div className="compact-value">{car?.ano_fabrico}</div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default CarInfoCard;
